import React, { useState, useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import { Auth } from 'aws-amplify';
import { useDispatch, useSelector } from 'react-redux';
import {
  DataGridContainer,
  GridContainer,
  LeftGrid,
  NoteHeading,
} from '../../../Episode.Styled';
import { EPISODE_CMP_LIST, EPISODE_CMP_DELETE_URL, paginationSize } from '../../../../../constants';
import { getCmpList } from './services/cmpApi';
import { deleteStopApi } from '../../../../../services/StopApi/StopApi';
import CmpDialog from '../CmpDialog/CmpDialog';
import {
  getCmpForm,
  resetCmpForm,
  setNewCmpForm,
} from '../../../../../redux/episode/cmpTab/cmpForm/cmpSlice';
import { getContactByUser } from '../../../../Contact/services/contactsApi';

const CmpList = (props) => {
  const episodeHeaderData = props.episodeHeaderData;
  const dispatch = useDispatch();
  const [user, setUser] = useState(null);
  const [openCmpDialog, setOpenCmpDialog] = useState(false);
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [cmpList, setCmpList] = useState({
    isLoading: false,
    data: [],
    pageSize: 10,
    total: 0,
    page: 1,
  });

  const episodeId = useSelector(
    (state) => state?.episodeDetail?.singleEpisode[0]?.episodeId
  );

  const cmpReferenceData = useSelector((state) => state?.cmpReferenceData);
  const { communityBasedProviderList, counselingStaffAssignedList } =
    cmpReferenceData;

  const getCommunityBasedProviderName = (Id) => {
    const getCommunityBasedProvider = communityBasedProviderList.find(
      (item) => item.id === Id
    );
    return getCommunityBasedProvider?.value;
  };

  const getCounselingStaffAssignedName = (Id) => {
    const getCounselingStaffAssigned = counselingStaffAssignedList.find(
      (item) => item.cntId === Id
    );
    return getCounselingStaffAssigned?.contactName;
  };

  useEffect(() => {
    const initUser = async () => {
      const userData = await getUser();
      setUser(userData);
    };

    if (!user) {
      initUser();
    } else if (user?.signInUserSession.accessToken.jwtToken) {
      fetchData();
    }
  }, [user, cmpList.page, cmpList.pageSize]);

  const getUser = async () => {
    try {
      const user = await Auth.currentAuthenticatedUser();
      try {
        const loggedInContact = await getContactByUser(user);
        user.contact = loggedInContact;
      } catch (error) {
        console.log('Error fetching contact');
      }
      return user;
    } catch (error) {
      console.log('Not signed in');
      return null;
    }
  };

  const fetchData = async () => {
    setCmpList((prveState) => ({ ...prveState, isLoading: true }));
    const commonParams = `${EPISODE_CMP_LIST}/${episodeId}?PageNumber=${cmpList.page}&PageSize=${cmpList.pageSize}`;
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    const cmpData = await getCmpList({
      commonParams,
      authorization,
      getCommunityBasedProviderName,
      getCounselingStaffAssignedName,
    });
    setCmpList((prveState) => ({
      ...prveState,
      ...cmpData,
    }));
  };

  const handleCmp = (rowData) => {
    dispatch(getCmpForm(rowData));
    setOpenCmpDialog(true);
    setOpenBackdrop(true);
    setTimeout(() => {
      setOpenBackdrop(false);
    }, 600);
  };

  const handleNewCmp = () => {
    dispatch(resetCmpForm());
    dispatch(setNewCmpForm(true));
    setOpenCmpDialog(true);
    setOpenBackdrop(true);
    setTimeout(() => {
      setOpenBackdrop(false);
    }, 600);
  };

  const handleDeleteCmp = async (params) => {
    if (!window.confirm('Are you sure you want to delete this Case Management Plan?')) {
      return;
    }

    const url = `${EPISODE_CMP_DELETE_URL}/${params.row.cmpId}`;
    const payload = {};
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;

    deleteStopApi({ url, payload, authorization }).then((response) => {
      console.log('### delete response');
      console.log(response);
      fetchData();
    }).catch((e) => alert(e));
  };

  const columnsData = [
    ...(user?.contact?.authLock === true ? [{
      field: 'actions',
      headerName: '',
      sortable: false,
      width: 80,
      renderCell: (params) => {
        return (
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              handleDeleteCmp(params);
            }}
          >
            <DeleteIcon />
          </IconButton>
        );
      },
    }] : []),
    {
      field: 'cmpId',
      headerName: 'Cmp Id',
      sortable: false,
      width: 200,
    },
    {
      field: 'communityBasedProviderName',
      headerName: 'Community Based Provider',
      sortable: false,
      width: 500,
    },
    {
      field: 'counselingStaffAssignedName',
      headerName: 'Counseling Staff Assigned',
      sortable: false,
      width: 500,
      flex: 1,
    },
  ];

  return (
    <>
      <GridContainer container>
        <Grid item xs={6}>
          <NoteHeading variant='h5'>
            To edit Cmp please click on particular row
          </NoteHeading>
        </Grid>
        <LeftGrid item xs={6}>
          <Button variant='contained' onClick={() => handleNewCmp()}>
            New Cmp
          </Button>
        </LeftGrid>
      </GridContainer>
      <DataGridContainer>
      <div style={{ height: 670, width: '100%' }}>
        <div style={{ display: 'flex', height: '100%' }}>
          <div style={{ flexGrow: 1 }}>
            <DataGrid
              //getRowHeight={() => 'auto'}
              columns={columnsData}
              rows={cmpList.data}
              rowCount={cmpList.total}
              rowsPerPageOptions={paginationSize}
              pageSize={cmpList.pageSize}
              pagination
              paginationMode='server'
              getRowClassName={(params) =>
                params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
              }
              onPageSizeChange={(newPageSize) =>
                setCmpList((prveState) => ({
                  ...prveState,
                  pageSize: newPageSize,
                }))
              }
              onPageChange={(newPage) => {
                setCmpList((prveState) => ({
                  ...prveState,
                  page: newPage + 1,
                }));
              }}
              loading={cmpList.isLoading}
              onRowClick={(param) => handleCmp(param.row)}
              disableColumnFilter
              disableColumnMenu
            />
          </div>
        </div>
      </div>      
      </DataGridContainer>
      <CmpDialog
        open={openCmpDialog}
        setOpen={setOpenCmpDialog}
        openBackdrop={openBackdrop}
        authToken={user?.signInUserSession.accessToken.jwtToken}
        fetchData={fetchData}
        episodeHeaderData = {episodeHeaderData}
        user = {user}
        
      />
    </>
  );
};
export default CmpList;
